;(function () {
  angular
    .module('contrast.security-controls')
    .controller(
      'EditRuleControlCtrl',
      function (
        $q,
        $scope,
        $routeParams,
        $location,
        $translate,
        $uibModal,
        dialogs,
        logger,
        csTemplates,
        RuleFactory,
        OrganizationFactory,
        RuleService,
        ApplicationService,
        ErrorService,
        UserService,
        securityControlService,
        LanguagesService,
        AGENT_LANGUAGE,
        SECURITY_CONTROL_TYPES
      ) {
        'ngInject'

        var controlId = $routeParams.controlId
        var ALL_OPTION = { title: 'All Rules', name: 'All Rules' }
        var ALL_APPS_OPTION = {
          app_id: 'ALL_APPS',
          name: $translate.instant('title_allApplications')
        }

        angular.extend($scope, {
          isEdit: true,
          languages: [],
          control_types: [],
          rules: [],
          applications: [],
          control: {},
          model: {
            title: $translate.instant('title_securityControlDrilldown_edit'),
            description: $translate.instant('detail_securityControl_edit'),
            btn_label: $translate.instant('action_save'),
            servers_java: [],
            servers_dotnet: [],
            rules: [],
            applications: [],
            relevantAgentLanguages: []
          }
        })

        angular.extend($scope, {
          saveControl: saveControl,
          deleteControl: deleteControl,
          openServers: openServers,
          onRulesUpdated: onRulesUpdated,
          onRulesDeleted: onRulesDeleted,
          onAppsUpdated: onAppsUpdated,
          onAppsDeleted: onAppsDeleted,
          isDotnetLanguage: isDotnetLanguage,
          getApiClass: getApiClass,
          getPatternClass: getPatternClass,
          isPatternValidator: isPatternValidator,
          getLanguageDisplayValue: getLanguageDisplayValue
        })

        function init() {
          LanguagesService.loadAgentLanguages()
            .then(handleAgentLanguagesResponse)
            .then(loadControl)
            .then(getRules)
            .then(getApplications)
            .then(checkServers)
            .then(setControlTypes)
            .catch(ErrorService.processError)
        }

        function setControlTypes() {
          $scope.control_types = !isDotnetLanguage()
            ? securityControlService.getControlTypes()
            : securityControlService.getUserDefineControlTypes()
        }

        function handleAgentLanguagesResponse(agentLanguages) {
          $scope.model.relevantAgentLanguages =
            securityControlService.filterRelevantAgentLanguages(agentLanguages)

          $scope.languages = securityControlService.getAgentLanguageKeys(
            $scope.model.relevantAgentLanguages
          )

          $scope.control.language = $scope.languages[0]
        }

        function loadControl() {
          return securityControlService
            .getSecurityControl(controlId)
            .then(function (control) {
              fillControl(control)
            })
        }

        function fillControl(data) {
          $scope.languages = [data.language]

          $scope.control.name = data.name
          $scope.control.language = data.language
          $scope.control.type = data.type

          $scope.control.module = data.module

          if (isPatternValidator()) {
            $scope.control.pattern = data.pattern

            if (data.all_applications) {
              $scope.control.all_applications = true
              $scope.model.applications.push(ALL_APPS_OPTION)
            } else {
              $scope.control.all_applications = false
              data.applications.forEach(function (app) {
                $scope.model.applications.push(app.app_id)
              })
            }
          } else {
            $scope.control.api = data.api
          }

          if (data.all_rules) {
            $scope.control.all_rules = true
            $scope.model.rules.push(ALL_OPTION)
          } else {
            $scope.control.all_rules = false
            for (var i = 0; i < data.rules.length; i++) {
              var rule = data.rules[i]
              $scope.model.rules.push(rule.name)
            }
          }
        }

        function getRules() {
          $scope.rules = []
          return RuleFactory.getEnabledRulesForControls(
            $scope.control.language
          ).then(function (response) {
            $scope.rules.push(ALL_OPTION)
            $scope.rules = _.union($scope.rules, response.data.rules)
          })
        }

        function getApplications() {
          $scope.applications = []
          return ApplicationService.getApplicationBase(false).then(function (
            apps
          ) {
            $scope.applications.push(ALL_APPS_OPTION)
            $scope.applications = _.union($scope.applications, apps)
          })
        }

        function checkServers() {
          return OrganizationFactory.getServerToRestartIfChange(
            AGENT_LANGUAGE.JAVA[0]
          )
            .then(function (response) {
              var data = response.data

              $scope.model.servers_java = data.servers
            })
            .then(function () {
              return $q.all({
                dotnet: OrganizationFactory.getServerToRestartIfChange(
                  AGENT_LANGUAGE.DOTNET[0]
                ),
                dotnetCore: OrganizationFactory.getServerToRestartIfChange(
                  AGENT_LANGUAGE.DOTNET_CORE[0]
                )
              })
            })
            .then(function (response) {
              $scope.model.servers_dotnet = response.dotnet.data.servers.concat(
                response.dotnetCore.data.servers
              )
            })
        }

        function saveControl() {
          var form = $scope.control

          var data = {
            name: form.name,
            language: form.language,
            all_rules: form.all_rules,

            module: form.module
          }

          if (isPatternValidator()) {
            data.pattern = form.pattern
            data.all_applications = form.all_applications

            if (!form.all_applications) {
              data.applications = $scope.model.applications
            }
          } else {
            data.api = form.api
          }

          if (!form.all_rules) {
            data.rules = $scope.model.rules
          }

          return securityControlService
            .updateSecurityControl(controlId, data)
            .then(function (messages) {
              logger.logSuccess(messages[0])
              $location.path(UserService.buildUrl('/rules/controls'), true)
            })
        }

        function deleteControl() {
          return csTemplates
            .loadAndInterpolate(
              'components-org/security-controls/delete.html',
              {
                controlName: $scope.control.name
              }
            )
            .then(
              function (interpolatedStr) {
                _deleteControl(interpolatedStr)
              },
              function () {
                logger.logError('Unable to load remove dialog')
              }
            )
        }

        function _deleteControl(msg) {
          return dialogs
            .confirm(
              $translate.instant('title_deleteSecurityControlDialog_delete'),
              msg,
              {
                size: 'sm',
                yes: $translate.instant('action_delete'),
                no: $translate.instant('action_cancel')
              }
            )
            .result.then(function () {
              return securityControlService
                .deleteSecurityControl(controlId)
                .then(function (messages) {
                  logger.logSuccess(messages[0])
                  $location.path(UserService.buildUrl('/rules/controls'), true)
                }, ErrorService.processError)
            })
        }

        function openServers() {
          $uibModal.open({
            templateUrl: 'components-org/security-controls/modal_server.html',
            controller: 'ControlServerModalInstanceCtrl',
            resolve: {
              servers: function () {
                return isDotnetLanguage()
                  ? $scope.model.servers_dotnet
                  : $scope.model.servers_java
              },
              org: function () {
                return UserService.getCurrentOrganizationId()
              }
            }
          })
        }

        function onRulesUpdated(item, model) {
          RuleService.onRulesUpdate($scope, item, model)
        }

        function onRulesDeleted(item, model) {
          RuleService.onRulesDelete($scope, item, model)
        }

        function onAppsUpdated(item, model) {
          if (model == ALL_APPS_OPTION) {
            $scope.model.applications = [ALL_APPS_OPTION]
            $scope.control.all_applications = true
          } else {
            $scope.model.applications = removeAllAppsOption(
              $scope.model.applications
            )
            $scope.control.all_applications = false
          }
        }

        function removeAllAppsOption(array) {
          var index = _.indexOf(array, ALL_APPS_OPTION.app_id)
          if (index != -1) {
            array = array
              .slice(0, index)
              .concat(array.slice(index + 1, array.length))
          }
          return array
        }

        function onAppsDeleted() {
          if ($scope.model.applications.length === 0) {
            $scope.control.all_applications = true
            $scope.model.applications.push(ALL_APPS_OPTION.app_id)
          }
        }

        function isDotnetLanguage() {
          return (
            _.includes(AGENT_LANGUAGE.DOTNET, $scope.control.language) ||
            _.includes(AGENT_LANGUAGE.DOTNET_CORE, $scope.control.language)
          )
        }

        function isPatternValidator() {
          return (
            $scope.control.type ===
            SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR.value
          )
        }

        function getApiClass() {
          var result =
            angular.isDefined($scope.form.api) &&
            $scope.form.api.$invalid &&
            !$scope.form.api.$pristine
              ? 'has-error '
              : ''

          return result + 'col-sm-9'
        }

        function getPatternClass() {
          var result =
            angular.isDefined($scope.form.pattern) &&
            $scope.form.pattern.$invalid &&
            !$scope.form.pattern.$pristine
              ? 'has-error '
              : ''

          return result + 'col-sm-9'
        }

        function getLanguageDisplayValue(languageValue) {
          var agentLanguage = $scope.model.relevantAgentLanguages.find(
            function (language) {
              return language.value === languageValue
            }
          )

          return typeof agentLanguage !== 'undefined'
            ? agentLanguage.display
            : ''
        }

        init()
      }
    )
})()
